enum UserTypes {
  Business = 'business',
  Personal = 'personal',
}
export default UserTypes;
